<template>
  <section class="middle_bg_wrapper" v-if="blogs.length">
    <div class="container">
      <section class="latest_blog_wrapper">
        <div class="title_2">
          <h1><img src="@/assets/images/blog_icon.svg" alt="blog_icon.svg"> Latest Blogs </h1>
        </div>

        <div class="latest_blogs">
          <div class="primary_blog">
            <div class="card blog_card">
              <img class="card-img-top" :src="blogs[0].imageUrl" alt="blog1.png">
              <div class="card-img-overlay d-flex align-items-end">
                <div>
                  <h4 class="card-title"> {{blogs[0].title}} </h4>
                  <p class="card-text">{{blogs[0].created_at}} </p>
                  <a class="btn btn_primary btn_load mt-2" data-toggle="modal" data-target="#blogDetails" @click="selectedBlogIndex = 0">Load More</a>
                </div>
              </div>
            </div>
          </div>

          <div class="secondry_blogs">
            <div class="card blog_card">
              <div class="secondry_blog_img">
                <img class="card-img-top" :src="blogs[1].imageUrl" alt="blog_3.png">
              </div>
              <div class="secondry_blog_content">
                <h4 class="card-title"> {{blogs[1].title}} </h4>
                <p class="card-text">{{blogs[1].created_at}} </p>

                <a class="btn btn_primary btn_load" data-toggle="modal" data-target="#blogDetails" @click="selectedBlogIndex = 1">Load More</a>
              </div>
            </div>
            <div class="card blog_card">
              <div class="secondry_blog_img">
                <img class="card-img-top" :src="blogs[2].imageUrl" alt="blog_3.png">
              </div>
              <div class="secondry_blog_content">
                <h4 class="card-title"> {{blogs[2].title}} </h4>
                <p class="card-text">{{blogs[2].created_at}} </p>

                <a class="btn btn_primary btn_load" data-toggle="modal" data-target="#blogDetails" @click="selectedBlogIndex = 2">Load More</a>
              </div>
            </div>
          </div>

        </div>

      </section>
      <div class="modal fade" id="blogDetails">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">{{blogs[selectedBlogIndex].title}}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <img src="@/assets/images/blog-readmore-bg.jpeg" class="mb-3" alt="">
              <p>
                {{blogs[selectedBlogIndex].description}}
                <!-- <img :src="blogs[0].imageUrl" class="mb-3 invisible" alt=""> -->
              </p>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">

              <button type="button" class="btn btn_submit" data-dismiss="modal">Close</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Blogs',
  data () {
    return {
      blogs: [],
      selectedBlogIndex: 0
    }
  },
  mounted () {
    this.fetchLatestBlogs()
  },
  methods: {
    fetchLatestBlogs () {
      this.$store
        .dispatch('fetchLatestBlogs')
        .then((resp) => {
          this.blogs = resp.data.blogs
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
/* position: absolute;
top: 1rem;
left: 1rem;
padding: 1rem;
background: #212121b0;
width: calc(100% - 2rem); */
</style>



// WEBPACK FOOTER //
// src/components/Blogs.vue